import { render, staticRenderFns } from "./BlogsContent.vue?vue&type=template&id=0d0d7b40"
import script from "./BlogsContent.vue?vue&type=script&lang=js"
export * from "./BlogsContent.vue?vue&type=script&lang=js"
import style0 from "./BlogsContent.vue?vue&type=style&index=0&id=0d0d7b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports